// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-d39af338]{fill:#656565}.cls-2[data-v-d39af338]{fill:#3f3f3f}", ""]);
// Exports
module.exports = exports;
